import uiEnums from 'enums/ui';
import { getInPercentageRollout, getWithinOfficeHours } from 'selectors/configuration';

// Snowplow Types
const CONTEXT_GLADLY = 'iglu:com.gladly/context_gladly/jsonschema/1-0-0';
const CONTEXT_SEARCH = 'iglu:com.gladly.sidekick/context_search/jsonschema/1-0-2';
const CONTEXT_SEARCH_RESULT = 'iglu:com.gladly.sidekick/context_search_result/jsonschema/1-0-0';
const CONTEXT_QUICK_ACTION = 'iglu:com.gladly.sidekick/context_quick_action/jsonschema/1-0-0';
const CONTEXT_WIDGET = 'iglu:com.gladly.sidekick/context_widget/jsonschema/2-0-0';

const EVENT_ONBOARDING_SUBMITTED = 'iglu:com.gladly.sidekick/event_onboarding_submitted/jsonschema/1-0-0';
const EVENT_CHAT_MESSAGE_SENT = 'iglu:com.gladly.sidekick/event_chat_message_sent/jsonschema/2-0-0';
const EVENT_LINK_CLICKED = 'iglu:com.gladly.sidekick/event_link_clicked/jsonschema/1-1-0';
const EVENT_SCREEN_VIEWED = 'iglu:com.gladly.sidekick/event_screen_viewed/jsonschema/1-0-0';
const EVENT_SEARCHED = 'iglu:com.gladly.sidekick/event_searched/jsonschema/1-0-0';
const EVENT_WIDGET_OPENED = 'iglu:com.gladly.sidekick/event_widget_opened/jsonschema/1-0-0';

const location_map = {
  [uiEnums.LOCATIONS.HOME]: 'home',
  [uiEnums.LOCATIONS.ANSWER]: 'answer',
  [uiEnums.LOCATIONS.CHAT]: 'chat',
  [uiEnums.LOCATIONS.OFFICE_HOURS]: 'after_hours',
};

let isSnowplowInitialized;

function initializeSnowplow(state) {
  if (isSnowplowInitialized) {
    return;
  }

  let config = state.configuration.config;
  if (!config.snowplowEndpoint) {
    return;
  }

  window.gladly_snowplow('newTracker', 'cf', config.snowplowEndpoint, {
    // Initialize a tracker
    appId: 'sidekick',
  });
  isSnowplowInitialized = true;
}

function getIsCustomerAuthenticated(tagName) {
  const elements = document.getElementsByTagName(tagName);
  if (elements.length) {
    return true;
  }
  return false;
}

export function setSnowplowUserId(state, userId) {
  initializeSnowplow(state);

  window.gladly_snowplow('setUserId', userId);
}

export function trackSnowplowEvent(state, eventSchema, data = {}, contexts = []) {
  initializeSnowplow(state);

  let config = state.configuration.config;
  let location = state.ui.locationHistory[state.ui.locationHistory.length - 1];
  let screen = location_map[location];

  let isCustomerAuthenticated = null;
  if (config.authenticatedTagName) {
    isCustomerAuthenticated = getIsCustomerAuthenticated(config.authenticatedTagName);
  }

  window.gladly_snowplow(
    'trackUnstructEvent',
    {
      schema: eventSchema,
      data,
    },
    [
      {
        schema: CONTEXT_WIDGET,
        data: {
          screen,
          visibility: state.ui.isVisible ? (state.ui.isMinimized ? 'minimized' : 'open') : 'hidden',
          isInOfficeHours: getWithinOfficeHours(state.configuration),
          isThrottled: !getInPercentageRollout(state.configuration),
          smoochAppId: config.appId,
          isCustomerAuthenticated,
        },
      },
      {
        schema: CONTEXT_GLADLY,
        data: {
          orgId: config.orgId,
          stage: config.gladlyStage,
          site: config.gladlySite,
        },
      },
      ...contexts,
    ]
  );
}

export default {
  CONTEXT_GLADLY,
  CONTEXT_SEARCH_RESULT,
  CONTEXT_SEARCH,
  CONTEXT_QUICK_ACTION,
  CONTEXT_WIDGET,

  EVENT_CHAT_MESSAGE_SENT,
  EVENT_ONBOARDING_SUBMITTED,
  EVENT_LINK_CLICKED,
  EVENT_SCREEN_VIEWED,
  EVENT_SEARCHED,
  EVENT_WIDGET_OPENED,
};
